import { type ReactElement } from 'react';
import { Box } from '@/ui/primitives';
import { ProjectSelectOptionContent } from './ProjectSelectOptionContent';
import {
  projectFilterOptionLabelContentGap,
  projectFilterOptionLabelFrameSx,
} from './ProjectSelectOptionContent.styles';
import type { ProjectDto } from '@flowqa/shared';

type ProjectFilterOptionContent = {
  label: string;
  badgeChars?: ProjectDto['badgeChars'];
  badgeColor?: ProjectDto['badgeColor'];
  badgeEnabled?: boolean;
  locked?: boolean;
  lockReason?: string | null;
};

export const renderProjectFilterOptionLabel = (
  option: ProjectFilterOptionContent,
): ReactElement => (
  <Box sx={projectFilterOptionLabelFrameSx}>
    <ProjectSelectOptionContent
      contentGap={projectFilterOptionLabelContentGap}
      project={{
        name: option.label,
        badgeEnabled:
          option.badgeEnabled === true &&
          option.badgeChars !== undefined &&
          option.badgeColor !== undefined,
        badgeChars: option.badgeChars ?? option.label,
        badgeColor: option.badgeColor ?? 'teal',
        locked: option.locked,
        lockReason: option.lockReason,
      }}
    />
  </Box>
);
